<div class="toolbar">
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="goToDetail()">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <label>Back To Order</label>
      </span>
    </button>
    <input type="checkbox" id="excludeCancelledInput" class="checkboxInput" [(ngModel)]="criteria.excludeCancelled" (change)="search()" [disabled]="isBusy()"/>
    <label for="excludeCancelledInput" class="checkboxLabel">Exclude Cancelled Releases</label>
  </span>
  <span class="spacer"></span>
</div>
<div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (releaseResults()) {
    <div class="results">
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Releases</td>
          </tr>
        </thead>
      </table>
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('ENTITY_ID')">
              <span>
                <label>ID</label>
                @if (criteria.sortColumn == 'ENTITY_ID') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('PROJECT_NAME')">
              <span>
                <label>Project Name</label>
                @if (criteria.sortColumn == 'PROJECT_NAME') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('APPROVAL_DATE')">
              <span>
                <label>Approve Dt</label>
                @if (criteria.sortColumn == 'APPROVAL_DATE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('FINAL_EXTENDED_AMOUNT')">
              <span>
                <label>Amount</label>
                @if (criteria.sortColumn == 'FINAL_EXTENDED_AMOUNT') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('UNIT_QUANTITY')">
              <span>
                <label>Qty</label>
                @if (criteria.sortColumn == 'UNIT_QUANTITY') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('LEAD_TIME')">
              <span>
                <label>Lead Time</label>
                @if (criteria.sortColumn == 'LEAD_TIME') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('RELEASE_NUMBER')">
              <span>
                <label>IEC Release #</label>
                @if (criteria.sortColumn == 'RELEASE_NUMBER') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('STATUS')">
              <span>
                <label>Status</label>
                @if (criteria.sortColumn == 'STATUS') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('MILESTONE')">
              <span>
                <label>Milestone</label>
                @if (criteria.sortColumn == 'MILESTONE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('ERP_STATUS')">
              <span>
                <label>ERP Status</label>
                @if (criteria.sortColumn == 'ERP_STATUS') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('SCHEDULE_DATE')">
              <span>
                <label>Schedule Dt</label>
                @if (criteria.sortColumn == 'SCHEDULE_DATE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('LAST_SHIP_DATE')">
              <span>
                <label>Last Ship Dt</label>
                @if (criteria.sortColumn == 'LAST_SHIP_DATE') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('TRACKING_NUMBER')">
              <span>
                <label>Tracking Info</label>
                @if (criteria.sortColumn == 'TRACKING_NUMBER') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
            <td class="tableCell centeredCell headerCell clickableCell" (click)="sortResults('TRUCKING_COMPANY')">
              <span>
                <label>Trucking Co</label>
                @if (criteria.sortColumn == 'TRUCKING_COMPANY') {
                  <span>
                    @if (!isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_up</mat-icon>
                    }
                    @if (isDescending()) {
                      <mat-icon class="size-16">keyboard_arrow_down</mat-icon>
                    }
                  </span>
                }
              </span>
            </td>
          </tr>
        </thead>
        @for (result of releaseResults(); track result; let rowIndex = $index) {
          <tr [class.selectedRow]="rowIndex === selectedRowId()" class="selectableRow" (click)="selectRow(rowIndex, result)">
            <td class="tableCell">{{ result.id.entityId }};{{ result.id.entityRevision }}</td>
            <td class="tableCell">{{ result.projectName }}</td>
            <td class="tableCell">{{ result.approvalDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell">{{ result.finalExtendedAmount | currency:'USD' }}</td>
            <td class="tableCell">{{ result.totalUnitQty }}</td>
            <td class="tableCell">{{ result.leadTime }}</td>
            <td class="tableCell">{{ result.releaseNumber }}</td>
            <td class="tableCell">{{ result.statusDescription }}</td>
            <td class="tableCell">{{ result.milestone }}</td>
            <td class="tableCell">{{ result.erpStatus }}</td>
            <td class="tableCell">{{ result.estimatedScheduleDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell">{{ result.lastShipDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell">{{ result.trackingNumber }}</td>
            <td class="tableCell">{{ result.truckingCompany }}</td>
          </tr>
        }
      </table>
    </div>
  }
  @if (maxPage() > 1) {
    <div class="resultNavigation toolbar">
      <span class="spacer"></span>
      <span>
        <button matButton="text" [disabled]="isBusy() || criteria.pageNumber === 1" (click)="previousPage()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <label>Previous</label>
          </span>
        </button>
        <label class="paginationStatus">Page {{ criteria.pageNumber }} of {{ maxPage() }}</label>
        <button matButton="text" [disabled]="isBusy() || criteria.pageNumber >= maxPage()" (click)="nextPage()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_right</mat-icon>
            <label>Next</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
    </div>
  }
</div>
